
import { Collada, ColladaLoader } from 'three/examples/jsm/loaders/ColladaLoader.js';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

type ObjectLoader = ColladaLoader | GLTFLoader;

export type ObjectType = Collada | GLTF;

export class Loader {
    public static supporGTLF = true;

    private url: string;

    constructor(url: string) {
        this.url = url;
    }

    public getLoader(): ObjectLoader {
        if (this.isCollada(this.url)) return new ColladaLoader();
        if (this.isGLTF(this.url)) return new GLTFLoader();
    }

    private isGLTF(url: string): boolean {
        return this.isExtension(url, "gltf") || this.isExtension(url, "glb");
    }

    private isCollada(url: string): boolean {
        //拡張子を取得した後、"Dae"とか"DAE"とかになっているケースがあるので、小文字変換を行い"dae"にして、それで確認する
        return this.isExtension(url, "dae");
    }

    //拡張子に一致するか
    private isExtension(url: string, ex: string): boolean {
        const extension = url.split('?').shift().split('.').pop();
        return (extension.toLowerCase() == ex);
    }

    public exitension() {
        return this.url.split('?').shift().split('.').pop().toLowerCase();
    }
}
